/**
 * Retorna o título da tela para exibição na AppTopBar (app Capacitor).
 * Rotas mais específicas devem vir antes das genéricas no map.
 */
export function getTitleFromPath(pathname: string): string {
  const path = pathname.replace(/\/$/, '') || '/';

  const titleMap: Record<string, string> = {
    // A barra do app diz o mesmo nome do item do menu e do título da tela (docs/PADRAO-DE-TELAS.md §2).
    '/teacher': 'Painel',
    '/teacher/simulations': 'Simulados',
    '/teacher/simulations/new': 'Novo simulado',
    '/teacher/relatorios': 'Relatórios',
    '/teacher/reports': 'Por Simulado',
    '/teacher/reports/students': 'Por Aluno',
    '/teacher/reports/descriptors': 'Por Habilidade',
    '/teacher/reports/proficiency': 'Níveis de Desempenho',
    '/teacher/reports/descriptor-evolution': 'Evolução por Habilidade',
    '/teacher/reports/descriptor-heatmap': 'Mapa de Habilidades',
    '/teacher/reports/proficiency-evolution': 'Evolução do Desempenho',
    '/teacher/reports/class-grades': 'Notas por Turma',
    '/teacher/reports/next-simulation': 'Próximo Simulado',
    '/teacher/reports/comparar-turmas': 'Comparar Turmas',
    '/teacher/reports/item-responses': 'Exportar respostas',
    '/teacher/curadoria': 'Curadoria',
    '/teacher/interventions': 'Registros de intervenção',
    '/teacher/questions/conjuntos-ancora': 'Conjuntos âncora',
    // As entradas em abas (26/10/2026): o nome do item do menu, em qualquer aba. Os endereços antigos redirecionam.
    '/teacher/turmas-e-alunos': 'Turmas e alunos',
    '/teacher/turmas-e-alunos/turmas': 'Turmas e alunos',
    '/teacher/turmas-e-alunos/alunos': 'Turmas e alunos',
    '/teacher/classificacao': 'Classificação',
    '/teacher/classificacao/disciplinas': 'Classificação',
    '/teacher/classificacao/conteudos': 'Classificação',
    '/teacher/classificacao/habilidades': 'Classificação',
    '/teacher/minha-escola': 'Escolas',
    '/teacher/questions': 'Questões',
    '/teacher/questions/import': 'Importar questões',
    '/teacher/questions/import/review': 'Revisão em lote',
    '/admin': 'Painel',
    '/admin/users': 'Usuários',
    '/admin/schools': 'Escolas',
    '/admin/classes': 'Turmas',
    '/admin/classificacao': 'Classificação',
    '/admin/classificacao/disciplinas': 'Classificação',
    '/admin/classificacao/conteudos': 'Classificação',
    '/admin/classificacao/habilidades': 'Classificação',
    '/admin/questions': 'Questões',
    '/admin/questions/import': 'Importar questões',
    '/admin/questions/import/review': 'Revisão em lote',
    '/admin/relatos': 'Relatos',
    '/admin/pedidos': 'Pedidos de acesso',
    '/admin/uso': 'Painel de uso',
    '/admin/curadoria': 'Curadoria',
    '/admin/importacoes': 'Importações',
    '/admin/rasch': 'Rasch',
    '/admin/bateria-omr': 'Bateria OMR',
    '/admin/escolas-em-revisao': 'Escolas em revisão',
    '/gestao': 'Painel',
    '/gestao/turmas-e-alunos': 'Turmas e alunos',
    '/gestao/turmas-e-alunos/turmas': 'Turmas e alunos',
    '/gestao/turmas-e-alunos/alunos': 'Turmas e alunos',
    '/gestao/professores': 'Professores',
    '/gestao/convites': 'Convites',
    '/gestao/questoes': 'Questões',
    '/gestao/simulados': 'Simulados',
    '/gestao/simulados/novo': 'Novo simulado',
    '/gestao/simulados/corrigir': 'Corrigir folhas',
    '/gestao/relatorios': 'Relatórios',
    '/gestao/relatorios/mapa': 'Mapa de Habilidades',
    '/gestao/relatorios/por-simulado': 'Por Simulado',
    '/gestao/relatorios/comparar-turmas': 'Comparar Turmas',
    '/gestao/relatorios/descritores': 'Por Habilidade',
    '/gestao/relatorios/proficiencia': 'Níveis de Desempenho',
    '/gestao/relatorios/notas': 'Notas por Turma',
    '/gestao/relatorios/respostas': 'Exportar respostas',
    '/gestao/relatorios/evolucao-descritor': 'Evolução por Habilidade',
    '/gestao/relatorios/evolucao-proficiencia': 'Evolução do Desempenho',
    '/gestao/curadoria': 'Curadoria',
    '/notificacoes': 'Notificações',
    '/testar-aparelho': 'Testar meu aparelho',
    '/como-usar': 'Como usar',
    '/privacidade': 'Privacidade',
    '/solicitar-acesso': 'Solicitar acesso',
    '/termos': 'Termos de uso',
    '/termos/aceitar': 'Termos de uso',
    '/conta': 'Minha conta',
    '/student': 'Meus simulados',
    '/student/quiz': 'Quiz',
  };

  if (titleMap[path]) return titleMap[path];

  // /teacher/simulations/:id/scan
  if (/^\/teacher\/simulations\/[^/]+\/scan$/.test(path)) return 'Corrigir pela câmera';
  // As telas de edição (22/10/2026, achado D12): caíam em "Portal Simulados".
  if (/^\/teacher\/simulations\/[^/]+\/edit$/.test(path)) return 'Editar simulado';
  if (/^\/(teacher|admin)\/questions\/\d+$/.test(path) || /^\/gestao\/questoes\/\d+$/.test(path)) return 'Questão';
  if (/^\/gestao\/simulados\/[^/]+\/(escanear|imprimir|leitores)$/.test(path)) return 'Simulado';

  // /student/simulation/:id
  if (/^\/student\/simulation\/[^/]+$/.test(path)) return 'Simulado';
  if (/^\/student\/correcao\/[^/]+$/.test(path)) return 'Correção';

  return 'Portal Simulados';
}
